import { render, staticRenderFns } from "./FreshConcrete.vue?vue&type=template&id=70a64a14&scoped=true"
import script from "./FreshConcrete.vue?vue&type=script&lang=js"
export * from "./FreshConcrete.vue?vue&type=script&lang=js"
import style0 from "./FreshConcrete.vue?vue&type=style&index=0&id=70a64a14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a64a14",
  null
  
)

export default component.exports